import { render, staticRenderFns } from "./ReClientCall.vue?vue&type=template&id=2f8cbb8b&scoped=true"
import script from "./ReClientCall.vue?vue&type=script&lang=js"
export * from "./ReClientCall.vue?vue&type=script&lang=js"
import style0 from "./ReClientCall.vue?vue&type=style&index=0&id=2f8cbb8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8cbb8b",
  null
  
)

export default component.exports